import { Tooltip } from 'stories/components'

export const LinkedEntitySelect = ({
  entityTitles,
  value,
  onChange,
}: {
  entityTitles: Record<string, string>
  value: string
  onChange: (value: string) => void
}) => (
  <Tooltip message="Link Entity">
    <select
      onChange={(e) => onChange(e.target.value)}
      value={value}
      className="block rounded py-0 px-2 text-sm text-gray-900 bg-transparent border border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
    >
      <option value=""></option>
      {Object.entries(entityTitles).map(([k, v]) => (
        <option key={k} value={k}>
          {v}
        </option>
      ))}
    </select>
  </Tooltip>
)
